import { Text, Flex } from '@servicetitan/anvil2';
import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { useLegalDisclosure } from '@servicetitan/financing-utils-shared';

export const FooterDisclosures = () => {
    const { setupData } = SetupDataStore.useStore();
    const { legalDisclosureCategory } = useProviderConfig();

    const legalDisclosureResult = useLegalDisclosure({
        providerName: setupData?.provider,
        tenantId: setupData?.tenantId,
        category: legalDisclosureCategory,
    });

    const hasLegalDisclosures = Array.isArray(legalDisclosureResult)
        ? legalDisclosureResult.length > 0
        : legalDisclosureResult && legalDisclosureResult !== '';

    if (!hasLegalDisclosures) {
        return null;
    }

    return (
        <Flex style={{ marginTop: '24px' }} direction="row" justifyContent="center">
            <Flex direction="row" gap={8} style={{ maxWidth: '845px' }} justifyContent="center">
                {Array.isArray(legalDisclosureResult) ? (
                    legalDisclosureResult.map(disclosure => (
                        <Text
                            key={disclosure}
                            variant="body"
                            subdued
                            size="small"
                            dangerouslySetInnerHTML={{
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                __html: disclosure,
                            }}
                        />
                    ))
                ) : (
                    <Text
                        variant="body"
                        subdued
                        size="small"
                        dangerouslySetInnerHTML={{
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            __html: legalDisclosureResult,
                        }}
                    />
                )}
            </Flex>
        </Flex>
    );
};
